// ============================================================================
// BonBoZ: định dạng THỜI LƯỢNG (giây → chữ) cho trang Thống kê.
//
// VÌ SAO CẦN: `formatTime` của `@chatwoot/utils` trả về tiếng Anh viết hoa kiểu
// tiêu đề và KHÔNG nhận locale:
//
//     45      -> "45 Sec"
//     330     -> "5 Min 30 Sec"
//     8100    -> "2 Hr 15 Min"
//     273600  -> "3 Day 4 Hr"
//
// Đó là GIÁ TRỊ nằm dưới mọi thẻ "Thời gian phản hồi đầu tiên" / "Thời gian
// giải quyết", trong mọi ô thời gian của bảng nhân viên/nhãn/hộp thư, và trong
// chú giải mọi biểu đồ. Nhãn thì tiếng Việt mà con số thì tiếng Anh.
//
// Giữ nguyên quy tắc của upstream để số liệu không đổi nghĩa: hiện TỐI ĐA hai
// đơn vị liền nhau, đơn vị nhỏ bị bỏ khi bằng 0.
// ============================================================================

const DON_VI = [
  { giay: 86400, vi: 'ngày', en: 'Day', viNgan: 'ng', enNgan: 'd' },
  { giay: 3600, vi: 'giờ', en: 'Hr', viNgan: 'g', enNgan: 'h' },
  { giay: 60, vi: 'phút', en: 'Min', viNgan: 'ph', enNgan: 'm' },
  { giay: 1, vi: 'giây', en: 'Sec', viNgan: 's', enNgan: 's' },
];

const laViet = () =>
  typeof document !== 'undefined' &&
  Boolean(document.documentElement.lang?.startsWith('vi'));

/**
 * @param {number} giay - thời lượng tính bằng giây.
 * @returns {string} ví dụ "2 giờ 15 phút" — hoặc "2 Hr 15 Min" khi đang tiếng Anh.
 */
export function dinhDangThoiLuong(giay) {
  const tong = Math.round(Number(giay) || 0);
  const vi = laViet();
  // Dưới một giây vẫn phải nói ra một con số, nếu không ô bảng trống trơn.
  if (tong < 1) return vi ? '0 giây' : '0 Sec';

  const i = DON_VI.findIndex(d => tong >= d.giay);
  const lon = DON_VI[i];
  const soLon = Math.floor(tong / lon.giay);
  const phan = [`${soLon} ${vi ? lon.vi : lon.en}`];

  // Đơn vị nhỏ liền kề, chỉ thêm khi khác 0 — "2 giờ" gọn hơn "2 giờ 0 phút".
  const nho = DON_VI[i + 1];
  if (nho) {
    const soNho = Math.floor((tong % lon.giay) / nho.giay);
    if (soNho > 0) phan.push(`${soNho} ${vi ? nho.vi : nho.en}`);
  }
  return phan.join(' ');
}

/**
 * Dạng NGẮN cho vạch trục biểu đồ — chỗ chỉ vừa vài ký tự.
 * Một đơn vị duy nhất, viết tắt: "45s", "5ph", "2g", "3ng".
 *
 * Viết tắt tiếng Việt phải tránh đụng nhau: "giây" và "giờ" cùng bắt đầu bằng
 * "g", nên giây dùng `s` (ai cũng đọc được) còn giờ mới là `g`.
 *
 * @param {number} giay - thời lượng tính bằng giây.
 * @returns {string} chuỗi rỗng khi không có số liệu — trục để trống đúng hơn là in "0".
 */
export function thoiLuongNgan(giay) {
  const tong = Math.round(Number(giay) || 0);
  if (!tong) return '';
  const vi = laViet();
  const dv = DON_VI.find(d => tong >= d.giay) || DON_VI[DON_VI.length - 1];
  return `${Math.floor(tong / dv.giay)}${vi ? dv.viNgan : dv.enNgan}`;
}
